webpackJsonp([12],{

/***/ "LOzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page_title__ = __webpack_require__("O7V0");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	null,
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1__components_page_title__["a" /* default */],
		null,
		'Page Not Found'
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'p',
		null,
		'Hmmmm, the page you were looking for doesn\'t appear to exist. If you believe this is in error, feel free to email me:'
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'p',
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'a',
			{ href: 'mailto:feedback@howickweather.co.nz' },
			'feedback@howickweather.co.nz'
		)
	)
);

var NotFoundPage = function (_Component) {
	_inherits(NotFoundPage, _Component);

	function NotFoundPage() {
		_classCallCheck(this, NotFoundPage);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	NotFoundPage.prototype.componentDidMount = function componentDidMount() {
		this.context.titleService.update('Not Found');
		this.context.tracking.recordPageView();
	};

	NotFoundPage.prototype.render = function render() {
		return _ref;
	};

	return NotFoundPage;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);

/***/ })

});


// WEBPACK FOOTER //
// route-not-found.chunk.6f316.js